import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
        <Row>
            <Col sm={6}><p className="mb-0 text-muted">{new Date().getFullYear()} © LINC</p></Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                {/* <p className="mb-0 text-muted">Designed by <a href="https://capdigisoft.com/" target="_blanck">  CAP Digisoft</a></p> */}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
